export default __webpack_public_path__ + "static/media/uber.72d5d012.png";